import { DELETE_PAYOUT_DOWNBANK, GET_PAYOUT_DOWNBANKS } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const Get_Payout_DownBanks = (payload) => {
  return apiInstance.post(GET_PAYOUT_DOWNBANKS, payload);
};
export const Delete_Payout_DownBank = (payload) => {
  return apiInstance.post(DELETE_PAYOUT_DOWNBANK, payload);
};
